export class AppSettings {
    // public static API_ENDPOINT = 'http://api2.pepsimem.net'; // http://service.pepsimem.net
    
    public static API_ENDPOINT = 'http://servis-api.itrooscloud.net'; //'http://110.36.230.218:8080'; //'http://localhost:54220'; //'http://10.6.6.167:8080'; //'http://service.pepsimem.net'; // http://servis-api.itrooscloud.net // http://service.pepsimem.net

    public static LOGIN_API = '/api/User/LogIn'; 

    public static USER_SEARCH_API = '/api/User/Search';
    public static CREATE_USER_API = '/api/User/Create';
    public static DELETE_USER_API = '/api/User/Delete/';
    public static Edit_USER_API = '/api/User/Edit';
    public static Edit_ROLE_API = '/api/User/EditRole';
    

    public static GET_STORAGE_LOCATION_API = '/api/User/GetStorageLocations/'
    public static GET_AREAS_API = '/api/User/GetAreas/'
    public static Update_AREAS_OUTLETS_API = '/api/Outlet/AssignUnAssign'

    
    public static DEPOT_SEARCH_API = '/api/StorageLocation/Search'
    public static GET_ALL_DEPOT_AREA_API = '/api/Area/GetAll/'
    public static Update_DEPOT_AREAS__API = '/api/Area/AssignUnAssign'



    public static AREA_SEARCH_API = '/api/Area/Search'
    public static TOWN_SEARCH_API = '/api/Town/Search'
 

    public static GET_ALL_AREA_TOWNS_API = '/api/Town/GetAll/' 
    public static GET_ALL_TOWN_OUTLETS_API = '/api/Outlet/GetAllForAssignment/'



    public static DASHBOARD_API = '/api/Dashboard/Dashboard/';

    public static CATALOG_GET_ALL_API = '/api/Catalog/GetAll';

    public static CATALOG_SEARCH_API = '/api/Catalog/Search';
    public static CATALOG_EDIT_API = '/api/Catalog/Edit';

    public static CATALOG_STATUS_UPDATE_API = '/api/Catalog/UpdateStatus';

    public static CATALOG_GET_ALL_AFTER_MODIFIED_API = '/api/Catalog/GetAllAfterDateModified';

    public static OUTLET_SEARCH_API = '/api/Outlet/Search';



    public static ORDER_GET_ALL_API = '/api/Order/GetAll';
    public static ORDER_SEARCH_API = '/api/Order/Search';
    public static ORDER_BREAKDOWN_API = '/api/Order/GetOrderItems';
    public static NEW_ORDER_ITEM_API = 'api/Order/NewOrderItems';



    public static VALIDATE_ORDER_API = '/api/Order/GetAllStatus';
    public static GET_ALL_PENDING_ORDERS_API = '/api/Order/GetAllPendingOrders'; // /{SalesOfficerId:int}
    public static ORDER_UPDATE_STATUS_API = '/api/Order/UpdateOrderItems';
    public static ORDER_DOWNLOAD_API = '/api/Order/GetExcelData/'
    public static GET_STOCK_API = '/api/StorageLocation/GetStock';

    
    public static GET_ALL_STOCK_API = '/api/StorageLocation/GetAllLocationStock';



    public static GET_PAYMENTS_API = '/api/PaymentTransaction/Search';  
    
    public static GET_PAYMENT_DETAILS_API = '/api/PaymentTransaction/Get/';
}


// WEBPACK FOOTER //
// ./src/app/shared/app-settings.ts